"use client";

import React from "react";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DynamicPage from "../components/meta/DynamicPage";
import Form from "../components/Form";

export default function Contact() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [FName, setFName] = useState("");
  const [cell, setCell] = useState("");
  const [message, setMessage] = useState("");
  const [pacakge, setPackage] = useState("");

  function sendMail() {
    console.log("Sending Email");

    if (FName && email && cell && pacakge) {
      localStorage.setItem("name", FName);
      localStorage.setItem("email", email);
      localStorage.setItem("cell", cell);
      localStorage.setItem("message", message);
      localStorage.setItem("pacakge", pacakge);

      // Prepare the FormData to include attachments
      const formData = new FormData();
      formData.append(
        "message",
        `Name : ${FName} <br/> Phone: ${cell} <br/> Email: ${email} <br/> Message: ${message} <br/> Package: ${pacakge}`
      );
      formData.append("subject", "Website Form Submission");
      formData.append("to", "info@hemsida.co.za");

      // Attach all files from a multiple file input
      const fileInput = document.getElementById("attachment"); // assume there’s an <input type="file" id="attachment" multiple>
      if (fileInput && fileInput.files.length > 0) {
        for (let i = 0; i < fileInput.files.length; i++) {
          formData.append("attachments[]", fileInput.files[i]); // Use "attachments[]" to indicate multiple files
        }
      }

      axios
        .post("https://hemsidaemail.vercel.app/send_Resend", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => alert("Message Sent"))
        .catch(() => alert("Failed to send email"));
      return navigate("/ThankYou");
    }

    return alert("Fill in all fields to continue");
  }

  const handlePackageChange = (e) => {
    setPackage(e.target.value);
  };

  return (
    <>
      <DynamicPage title="Contact" />;
      <div className="container py-4">
        <div className=" text-center mb-4">
          <h2>Contact Us</h2>
          <p class="section-title px-5">
            <span class="px-2">Get In Touch</span>
          </p>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="bg-light p-4 rounded shadow">
              <h2 className="h5 fw-bold mb-3">Contact Details</h2>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <strong>Phone Number:</strong> 084 250 3620
                </li>
                <li className="mb-2">
                  <strong>Email:</strong>{" "}
                  <span>
                    <a href="mailto:info@hemsida.co.za">info@hemsida.co.za</a>
                  </span>
                </li>
                <li className="mb-2">
                  <strong>Working Hours:</strong> Mon-Fri, 9 AM - 5 PM
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <Form />
          </div>
        </div>
      </div>
    </>
  );
}
